/**
 * Whether this browser exposes the Notification API.
 *
 * Reads `Notification` as a property of `window` rather than as a bare global: where the API is absent
 * (Safari private browsing, older iOS WebViews) the identifier is *undeclared*, so naming it directly
 * throws a `ReferenceError` that optional chaining cannot catch.
 */
export function notificationsSupported(): boolean {
  return typeof window !== "undefined" && "Notification" in window;
}

/**
 * The Notification permission, or `undefined` where the browser does not expose the API at all.
 *
 * `undefined` is deliberately distinct from `"denied"`: the API being missing is not the user having
 * refused. Callers comparing against `"granted"` treat both as not-granted without special-casing.
 */
export function notificationPermission(): NotificationPermission | undefined {
  return notificationsSupported() ? window.Notification.permission : undefined;
}
